import ConfirmationPage from '../../shared/booking/ConfirmationPage';
import SightseeingSummary from './SightseeingSummary';

export default function SightseeingConfirmation() {
  return (
    <ConfirmationPage
      module="sightseeing"
      Summary={SightseeingSummary}
      refLabel="Voucher no."
      nextSteps={[
        'Your mobile voucher has been emailed — no printout needed.',
        'Arrive at the meeting point 15 minutes early.',
        'Carry a valid photo ID matching the lead traveller name.',
        'Free cancellation up to 24 hours before — manage from My Trips.',
      ]}
    />
  );
}
